// extracted by mini-css-extract-plugin
module.exports = {"icon-plus":"_3vwSemxWSDNjEmJ1bW4Lrz","iconPlus":"_3vwSemxWSDNjEmJ1bW4Lrz","button":"_3p1v-ar7rOQQUW7fKKAG1D"};